import moment from 'moment'
import { API } from '@/models/core'
import { KabaddiMatch } from '@/models/kabaddi/match'
import { KabaddiSeasonSchedule } from '@/models/kabaddi/schedule'

export class KabaddiSeasonPointsTable {
  static createFromJson (raw) {
    let table = new KabaddiSeasonPointsTable()
    table = Object.assign(table, raw)
    return table
  }
}

export class KabaddiSeasonStats {
  static createFromJson (raw) {
    let stats = new KabaddiSeasonStats()
    stats = Object.assign(stats, raw)
    return stats
  }
}

export class KabaddiSeasonTeam {
  static createFromJson (raw) {
    let team = new KabaddiSeasonTeam()
    team = Object.assign(team, raw)
    return team
  }
}

export class KabaddiSeasonTeamStats {
  static createFromJson (raw) {
    let stats = new KabaddiSeasonTeamStats()
    stats = Object.assign(stats, raw)
    return stats
  }
}

export class KabaddiSeasonPlayerStats {
  static createFromJson (raw) {
    let stats = new KabaddiSeasonPlayerStats()
    stats = Object.assign(stats, raw)
    return stats
  }
}

export class KabaddiSeason {
  static createFromJson (raw) {
    let season = new KabaddiSeason()
    season = Object.assign(season, raw)
    season.startDate = moment.unix(season.start_date.timestamp)
    return season
  }

  static fetch (key) {
    return API.instance().get(`/kabaddi/season/${key}/`).then((resp) => {
      const raw = resp.data.data
      const season = KabaddiSeason.createFromJson(raw.season)
      const recentMatches = []
      raw.recent_matches.forEach((raw) => {
        recentMatches.push(KabaddiMatch.createFromJson(raw))
      })
      // season.pointsTable = KabaddiSeasonPointsTable.createFromJson(raw.points_table)
      // season.stats = KabaddiSeasonStats.createFromJson(raw.stats)
      return { season, recentMatches }
    })
  }

  static fetchSchedule (key) {
    return API.instance().get(`/kabaddi/season/${key}/schedule/`).then((resp) => {
      const raw = resp.data.data
      const months = []
      raw.months.forEach((rawMonth) => {
        months.push(KabaddiSeasonSchedule.createFromJson(rawMonth))
      })
      return months
    })
  }

  static fetchPointsTable (key) {
    return API.instance().get(`/kabaddi/season/${key}/points-table/`).then((resp) => {
      const raw = resp.data.data
      const pointsTable = KabaddiSeasonPointsTable.createFromJson(raw.points_table)
      return pointsTable
    })
  }

  static fetchStats (key) {
    return API.instance().get(`/kabaddi/season/${key}/stats/`).then((resp) => {
      const raw = resp.data.data
      const stats = KabaddiSeasonStats.createFromJson(raw.stats)
      return stats
    })
  }

  static fetchTeam (key, teamkey) {
    return API.instance().get(`/kabaddi/season/${key}/team/${teamkey}/`).then((resp) => {
      const raw = resp.data.data
      const team = KabaddiSeasonTeam.createFromJson(raw.team)
      const stats = KabaddiSeasonTeamStats.createFromJson(raw.stats)
      return { team, stats }
    })
  }

  static fetchPlayer (key, playerkey) {
    return API.instance().get(`/kabaddi/season/${key}/player/${playerkey}/`).then((resp) => {
      const raw = resp.data.data
      const player = {}
      const stats = KabaddiSeasonPlayerStats.createFromJson(raw.stats)
      return { player, stats }
    })
  }
}
